import React, { useState, useEffect } from "react";
import Logo from "../assets/logo.png";
import { tenantConfig } from "../config/tenantConfig";
import { Spinner } from "./Spinner";
import { Loader2 } from "lucide-react";

interface SplashProps {
  show: boolean;
  fullScreen?: boolean;
}

const FADE_OUT_DURATION = 300;

export const Splash: React.FC<SplashProps> = ({ show, fullScreen = false }) => {
  const [isVisible, setIsVisible] = useState(show);
  const [isMounted, setIsMounted] = useState(show);

  useEffect(() => {
    if (show) {
      setIsMounted(true);
      setIsVisible(true);
    } else {
      setIsVisible(false);
      const timeout = setTimeout(() => setIsMounted(false), FADE_OUT_DURATION);
      return () => clearTimeout(timeout);
    }
  }, [show]);

  if (!isMounted) return null;

  // 1. Uygulama İlk Açılışında Tam Ekran Splash
  if (fullScreen) {
    return (
      <div
        className={`fixed inset-0 flex items-center justify-center z-[9999] bg-bg transition-opacity duration-300 ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
      >
        <div className="relative flex flex-col items-center gap-4">
          <div className="absolute inset-0 w-32 h-32 bg-primary/20 blur-3xl rounded-full animate-pulse" />
          <div className="relative flex items-center justify-center">
            <Spinner size="lg" color="border-primary" />
            <div className="absolute w-16 h-16 flex items-center justify-center">
              <img
                src={tenantConfig.logo === "/logo.png" ? Logo : tenantConfig.logo}
                alt={tenantConfig.name}
                className="w-full h-full object-contain animate-pulse"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 2. Rutin API İstekleri Sırasında Sağ Alt Köşede Çıkan ve Ekranı Kilitlemeyen Bildirici
  return (
    <div className="fixed bottom-6 right-6 z-[9999] pointer-events-none select-none">
      <div
        className={`flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-card/95 dark:bg-card/95 backdrop-blur-xl border border-borderColor/80 shadow-[0_10px_35px_rgba(0,0,0,0.15)] text-text transition-all duration-300 ease-out transform ${
          isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-4 scale-95"
        }`}
      >
        <div className="relative flex items-center justify-center w-5 h-5">
          <Loader2 size={18} className="animate-spin text-primary shrink-0" />
        </div>
        <div className="flex flex-col min-w-0 pr-1">
          <span className="text-xs font-black tracking-tight text-text flex items-center gap-1.5">
            İşlem Yapılıyor
            <span className="w-1.5 h-1.5 rounded-full bg-primary animate-ping" />
          </span>
          <span className="text-[10px] font-semibold text-text/50">Lütfen bekleyiniz...</span>
        </div>
      </div>
    </div>
  );
};